import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import '../../common/scss/tag.selectbox.scss';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import UnverifiedIcon from '../../../assets/icon/Unverified.svg';
import {
  getDependentSubscriptionBadge,
  isPayByCamp,
} from '../../../utils/utils';

const KidSelectbox = (params) => {
  const {
    tagList,
    selectedFilter,
    selectedDependent,
    setSelectedDependent,
    showListWithTag,
  } = params;
  const [showPane, setShowPane] = useState(false);
  const [rotate, setRotate] = useState('');
  const [tagOn, setTagOn] = useState(false);
  const { dependent, fetchAPI } = useAuth();
  const history = useHistory();

  //   useEffect(() => {
  //     setTagOn(selectedTag !== '');
  //     if (selectedTag === '') return;
  //     showListWithTag();
  //   }, [selectedTag]);

  //   useEffect(() => {
  //     if (selectedFilter !== 'tag') setSelectedTag('');
  //   }, [selectedFilter]);

  const rotateArrow = () => {
    setRotate(rotate === 'rotate-180' ? 'rotate-360' : 'rotate-180');
  };

  const handleSelectboxClick = (e) => {
    setShowPane(!showPane);
    rotateArrow();
  };

  const handleClick = (id) => {
    const tag = id;
    if (selectedDependent.id === Number(tag)) return;
    setSelectedDependent(tagList.find((element) => {
      return element.id === Number(tag)
    }));
    localStorage.setItem('set_dependent', tagList.find((element) => {
      return element.id === Number(tag)
    }).username)
    localStorage.setItem('set_dependent_id', tagList.find((element) => {
      return element.id === Number(tag)
    }).id)
    setShowPane(false);
    rotateArrow();
  };
  const gaurdianSignUp = () => {
    history.push('/onboarding/step1')
  }

  const getTagClass = (tag) => {
    if (tag?.is_verified) {
      if (tag?.subscriptions?.nickname !== "Villagers" && tag?.subscriptions?.nickname !== "Branches" && tag?.profile?.tribe_request_status === "accept" && isPayByCamp(tag?.school_details?.pay_by)) {
        return 'green-plan-color';
      } else {
        if (tag?.subscriptions?.subscription_id) {
          switch (tag?.subscriptions?.nickname) {
            case 'Villagers':
              return 'villagers-color';
            case 'Branches':
              return 'villagers-color';
            case 'Seedlings V2':
              return 'green-plan-color';
            case 'Roots':
              return 'green-plan-color'
            case 'Seedlings':
              return 'green-plan-color'
            default:
              break;
          }
        } else {
          return 'emeralat-color'
        }
      }
    } else {
      return 'unverify-color'
    }
  }

  return (
    <div className="tagSelectbox-container kid-select" id='guardian-step-eight'>
      <div
        className={`filter  tag-selectbox ${tagOn ? 'tag-selected' : ''}`}
        onClick={handleSelectboxClick}
      >
        <div className="selected-tag tag-whats">
          {selectedDependent?.username === '' ? "Select Kid" :
            <div className='kid-select-box-wrapper'>
              {selectedDependent?.username}
            </div>
          }
        </div>
        <div className={`selectbox-arrow ${rotate}`}></div>
      </div>
      <div className={`tag-list-pane ${showPane ? 'show' : 'hide'}`}>
        {tagList.length && tagList.map((tag, key) => {
          return (
            <div
              className={`tag-item tag-item-E ${getTagClass(tag)}`}
              onClick={() => handleClick(tag?.id)}
              data-tag={tag.id}
              key={`item-${key}`}
            >
              <div className="kid-select-box-wrapper ">
                <img
                  src={getUserProfileUrl(tag)}
                  alt={tag?.username}
                  className="kid-select-box-list-img batch-uni-image batch-uni-image-u"
                />
                {getDependentSubscriptionBadge(tag) === 'X' ? (
                  <span className="badgeWrapper badgeWrapper-un">
                    <img
                      src={UnverifiedIcon}
                      className=""
                      alt="Unverified Icon"
                    />
                  </span>
                ) : (
                  <span
                    className={`badgeWrapper ${
                      getDependentSubscriptionBadge(tag) === 'S'
                        ? 'badgeWrapper-S'
                        : getDependentSubscriptionBadge(tag) === 'E'
                        ? 'badgeWrapper-E'
                        : 'badgeWrapper-V'
                    }`}
                  >
                    {getDependentSubscriptionBadge(tag)}
                  </span>
                )}
                <span>{tag.username}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KidSelectbox;
